import React from 'react';
import styles from './Notification.module.css';
import { Icon } from '@fluentui/react';

interface NotificationProps {
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
  onDismiss: () => void;
  autoClose?: number;
}

export const Notification: React.FC<NotificationProps> = ({
  type,
  message,
  onDismiss,
  autoClose = 5000,
}) => {
  React.useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(onDismiss, autoClose);
      return () => clearTimeout(timer);
    }
  }, [autoClose, onDismiss]);

  const iconName = {
    success: 'CheckMark',
    error: 'ErrorBadge',
    info: 'Info',
    warning: 'Warning',
  }[type];

  return (
    <div className={`${styles.notification} ${styles[type]}`}>
      <Icon iconName={iconName} className={styles.icon} />
      <span className={styles.message}>{message}</span>
      <button className={styles.closeButton} onClick={onDismiss} aria-label="Close">
        ×
      </button>
    </div>
  );
};
